import { useEffect, useState } from "react";
import isNumber from "../../helpers/isNumber.helper";
import { connectOddbutton } from "./oddbutton.connect";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";
import { useSelector } from "react-redux";

const OddButton = connectOddbutton()(({
  market,
  auth,
  oddData,
  balanceSettings,
  isBack,
  betPlacing,
  oneClick,
  actions,
  // showBlock = true,
  showEmpty = false,
  // centered = false,
  // mainBlock = true,
  isFancy = false,
  marketNum,
  setClicked,
  clicked,
  isInactive = false,
  sportLimits,
  category,
  inplay,
}) => {
  const [odd, setOdd] = useState(null);
  const [isChanged, setIsChanged] = useState(false);
  const betDelayData = useSelector((state) => state.sportEvent?.betDelay);

  // const [color, setColor] = useState("");

  const getBtnActive = () => {
    const isNotActive = isBtnNotActive()
      ? " opacity-50 cursor-not-allowed "
      : " opacity-100 cursor-pointer active:scale-95 ";
    const active =
      !isNotActive &&
      betPlacing.market === (market && market.id) &&
      betPlacing.runner === (oddData && oddData.runner && oddData.runner.id) &&
      betPlacing.isBack === isBack &&
      marketNum === clicked
        ? "active"
        : "";
    return `${isNotActive} ${active} `;
  };

  useEffect(() => {
    const isNotActive = isBtnNotActive() ? "not-active" : "";
    const active =
      !isNotActive &&
      betPlacing.market === (market && market.id) &&
      betPlacing.runner === (oddData && oddData.runner && oddData.runner.id) &&
      betPlacing.isBack === isBack &&
      marketNum === clicked
        ? "active"
        : "";

    if (
      active &&
      betPlacing.priceActual !== (oddData && oddData.price) &&
      (betPlacing.marketType == "MATCH_ODDS" ||
        betPlacing.marketType == "MATCH_ODDS" ||
        betPlacing.marketType == "SESSION")
    ) {
      actions.setPriceActual(oddData && oddData.price);
    }
  }, [betPlacing?.priceActual, oddData?.price]);

  const isBtnNotActive = () => {
    if (isFancy) {
      return market?.is_active !== 1 || isInactive;
    } else {
      return (
        market?.status !== "OPEN" ||
        !oddData?.runner?.status ||
        !oddData?.runner?.status === "SUSPENDED" ||
        isInactive
      );
    }
  };

  const getOddPrice = (oddData = odd) => {
    const price = oddData && oddData.price;
    return price;
  };

  const getPriseFor_SB = (marketId) => {
    return marketId && marketId.slice(marketId.length - 3) === "_SB"
      ? ((odd?.price - 1) * 100).toFixed(2).replace(".00", "")
      : odd?.price;
  };

  const getOddVolume = () => {
    const size = odd && odd.size;
    const volumeMultiplier =
      (market &&
        balanceSettings &&
        balanceSettings.settings &&
        balanceSettings.settings[market.eventTypeId] &&
        balanceSettings.settings[market.eventTypeId].volumeMultiplier) ||
      1;
    if (!size) {
      return;
    }
    if (market?.id?.includes("_BR")) {
      return null;
    }
    if (market?.mtype && market?.mtype === "MATCH_ODDS_SB") {
      return;
    }
    const resultVolume = Math.ceil(size * volumeMultiplier);
    return (
      <div className="odd-button__volume">
        {resultVolume >= 500000
          ? "500.000+"
          : oddData?.category === 4
            ? "--"
            : getCurrencyFormat(resultVolume)}
      </div>
    );
  };

  const getFancyOddVolume = () => {
    const size = oddData && (isBack ? oddData.BackSize1 : oddData.LaySize1);
    const volumeMultiplier =
      (market &&
        balanceSettings &&
        balanceSettings.settings &&
        balanceSettings.settings[market.eventTypeId] &&
        balanceSettings.settings[market.eventTypeId].volumeMultiplier) ||
      1;
    if (!size) {
      return;
    }
    if (market?.id?.includes("_BR")) {
      return null;
    }
    if (market?.mtype && market?.mtype === "MATCH_ODDS_SB") {
      return;
    }
    const resultVolume = Math.ceil(size * volumeMultiplier);
    return (
      <div className="odd-button__volume">
        {resultVolume >= 500000
          ? "500.000+"
          : oddData?.category === 4
            ? "--"
            : getCurrencyFormat(resultVolume)}
      </div>
    );
  };

  const select = () => {
    let marketId;
    let runnerId;
    let limits;
    if (isFancy) {
      const fancyMin =
        !market?.user_setting_limit && !inplay
          ? market?.session_before_inplay_min_stack
          : !market?.user_setting_limit && inplay
            ? market?.session_min_stack
            : sportLimits?.check_event_limit
              ? sportLimits?.data?.session[market?.fancy_id?.fancy_id]
                  ?.session_min_stack
              : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_FANCY
                ? inplay
                  ? sportLimits?.data?.session_advance_limites?.[
                      market?.category
                    ]?.session_min_stack
                  : sportLimits?.data?.session_advance_limites?.[
                      market?.category
                    ]?.session_before_inplay_min_stack
                : sportLimits?.data?.session?.session_min_stack;
      const fancyMax =
        !market?.user_setting_limit && !inplay
          ? market?.session_before_inplay_max_stack
          : !market?.user_setting_limit && inplay
            ? market?.session_max_stack
            : sportLimits?.check_event_limit
              ? sportLimits?.data?.session[market?.fancy_id?.fancy_id]
                  ?.session_max_stack
              : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_FANCY
                ? inplay
                  ? sportLimits?.data?.session_advance_limites?.[
                      market?.category
                    ]?.session_max_stack
                  : sportLimits?.data?.session_advance_limites?.[
                      market?.category
                    ]?.session_before_inplay_max_stack
                : sportLimits?.data?.session?.session_max_stack;
      const fancyMaxPro =
        !market?.user_setting_limit && !inplay
          ? market?.session_before_inplay_max_profit
          : !market?.user_setting_limit && inplay
            ? market?.session_max_stack
            : sportLimits?.check_event_limit
              ? sportLimits?.data?.session[market?.fancy_id?.fancy_id]
                  ?.session_max_profit
              : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_FANCY
                ? inplay
                  ? sportLimits?.data?.session_advance_limites?.[
                      market?.category
                    ]?.session_max_profit
                  : sportLimits?.data?.session_advance_limites?.[
                      market?.category
                    ]?.session_before_inplay_max_profit
                : sportLimits?.data?.session?.session_max_profit;

      actions?.setMaxWinPerMarket(fancyMaxPro);

      marketId = market && market.fancy_id;
      runnerId = market && market.selection_id;
      limits =
        sportLimits &&
        sportLimits?.data &&
        sportLimits?.data?.session &&
        sportLimits?.data?.session[marketId];

      actions.setMaxBet(getCurrencyFormat(fancyMax));
      actions.setMinBet(getCurrencyFormat(fancyMin));
    } else {
      const isAdvanced = !market?.user_setting_limit && !market?.inplay;
      const isMarket = !market?.user_setting_limit && market?.inplay;

      const maxLimit = isAdvanced
        ? getCurrencyFormat(market?.market_advance_bet_stake)
        : isMarket
          ? getCurrencyFormat(market?.market_max_stack)
          : getCurrencyFormat(
              sportLimits?.check_event_limit
                ? sportLimits?.data[market?.market_id]?.market_max_stack
                : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
                  ? market?.inplay
                    ? sportLimits?.data?.market_advance_limites?.[
                        market?.market_type
                      ]?.market_max_stack
                    : sportLimits?.data?.market_advance_limites?.[
                        market?.market_type
                      ]?.market_advance_bet_stake
                  : sportLimits?.data?.market?.market_max_stack,
            );
      const maxLimitProfit = isAdvanced
        ? market?.market_advance_bet_stake
        : isMarket
          ? market?.market_max_stack
          : sportLimits?.check_event_limit
            ? sportLimits?.data[market?.market_id]?.market_max_profit
            : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
              ? market?.inplay
                ? sportLimits?.data?.market_advance_limites?.[
                    market?.market_type
                  ]?.market_max_profit
                : sportLimits?.data?.market_advance_limites?.[
                    market?.market_type
                  ]?.market_advance_max_profit
              : sportLimits?.data?.market?.market_max_profit;
      const minLimit = isAdvanced
        ? getCurrencyFormat(market?.market_advance_bet_min_stake)
        : isMarket
          ? getCurrencyFormat(market?.market_min_stack)
          : getCurrencyFormat(
              sportLimits?.check_event_limit
                ? sportLimits?.data[market?.market_id]?.market_min_stack
                : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
                  ? market?.inplay
                    ? sportLimits?.data?.market_advance_limites?.[
                        market?.market_type
                      ]?.market_min_stack
                    : sportLimits?.data?.market_advance_limites?.[
                        market?.market_type
                      ]?.market_advance_bet_min_stake
                  : sportLimits?.data?.market?.market_min_stack,
            );

      actions.setMaxBet(maxLimit);
      actions.setMinBet(minLimit);

      actions?.setMaxWinPerMarket(maxLimitProfit);
      marketId = market && market.market_id;
      runnerId =
        (oddData && oddData.runner && oddData.runner.id) || oddData.selectionId;
      limits = sportLimits && sportLimits?.data && sportLimits?.data[marketId];
    }
    if (!marketId || !runnerId) return;
    actions.setMarket(marketId);
    actions.setMarketName(market && market?.market_name);
    actions.setMarketType(
      market && market?.fancy_id ? "SESSION" : market?.market_type,
    );
    actions.setRunner(
      isFancy ? (isBack ? oddData?.BackSize1 : oddData?.LaySize1) : runnerId,
    );
    actions.setRunnerName(oddData && oddData.runner && oddData.runner.name);
    actions.setEventName(market && market.market_name);
    actions.setEventId(market && market?.match_id);
    actions.setIsBack(isBack);
    actions.setPrice(
      isFancy
        ? isBack
          ? oddData?.BackPrice1
          : oddData?.LayPrice1
        : oddData.price,
    );
    actions.setPriceActual(
      isFancy
        ? isBack
          ? oddData?.BackPrice1
          : oddData?.LayPrice1
        : oddData.price,
    );

    actions.setDelay(
      market?.fancy_id
        ? betDelayData?.session_bet_delay
        : betDelayData?.market_bet_delay,
    );
    actions.setMtype(market && market.mtype);
    actions.setBtype(market && market.btype);
    actions.setLine(isFancy);
    actions.setStartTime(market && market?.match_date);
    actions.setEventTypeId(market && market.eventTypeId);
    actions.setIsCashOut(false);
    actions.setMarketAll(market);
    // actions?.setMaxWinPerMarket(
    //   (limits && limits.market_max_profit) ||
    //     (limits && limits.session_max_profit),
    // );
    if (oneClick.active) {
      actions.setStake(oneClick.settings[oneClick.selected - 1]);
      actions.setBetPlacingPopoverStage(false);
      actions.setShowBetPlacingPopover(true);
      actions.setFromOneClick(true);
    } else {
      actions.setFromOneClick(false);
      // actions.setStake(null)
    }
  };

  useEffect(() => {
    if (isDataChanged()) {
      setIsChanged(true);
      setTimeout(() => {
        setIsChanged(false);
      }, 300);
      setOdd(oddData);
    }
  }, [oddData?.price, oddData?.size]);

  const isDataChanged = () => {
    return (
      getOddPrice() !== getOddPrice(oddData) || odd?.size !== oddData?.size
    );
  };

  return (
    <>
      <span
        className="flex items-center justify-center w-full h-full p-[1px] md:p-[2px] overflow-hidden"
        onClick={() => {
          if (
            !isBtnNotActive() &&
            oddData &&
            (isFancy
              ? isBack
                ? oddData?.BackPrice1
                : oddData?.category !== 4 && oddData?.LayPrice1
              : oddData.price) > 0
          ) {
            setClicked && setClicked(marketNum);
            select();
          }
        }}
      >
        <div
          className={` overflow-hidden relative   ${getBtnActive()} w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center ${
            isBack
              ? "bg-bg_BackBtnBg border border-backBtn"
              : "bg-bg_LayBtnBg border border-layBtn"
          }  undefined`}
        >
          <span
            id="oddBtnPrice"
            className="relative z-10 transition-all ease-in-out duration-300 origin-center flex items-center justify-center w-full text-text_OddValue leading-5 text-sm md:text-[15px] font-semibold "
          >
            {isFancy
              ? isNumber(
                  Number(
                    isBack
                      ? oddData?.BackPrice1
                      : oddData?.category === 4
                        ? "--"
                        : oddData?.LayPrice1,
                  ),
                ) &&
                !!oddData &&
                (isBack ? oddData?.BackPrice1 : oddData?.LayPrice1)
              : isNumber(Number(odd?.price)) &&
                  (odd?.price === 0 || !odd?.price)
                ? "-"
                : isNumber(Number(odd?.price))
                  ? getCurrencyFormat(getPriseFor_SB(market && market.id))
                  : showEmpty
                    ? "-"
                    : "-"}
          </span>
          <span
            id="oddBtnSize"
            className=" relative z-10 transition-all ease-in-out duration-300 origin-center flex items-center justify-center w-full text-[10px] text-text_OddValue leading-3 text-center whitespace-normal font-normal "
          >
            <span className="w-max break-all truncate">
              {isFancy
                ? isNumber(
                    Number(
                      isBack
                        ? oddData?.BackPrice1
                        : oddData?.category === 4
                          ? "--"
                          : oddData?.LayPrice1,
                    ),
                  ) && (isBack ? oddData?.BackPrice1 : oddData?.LayPrice1) === 0
                  ? "-"
                  : isNumber(
                        Number(
                          isBack ? oddData?.BackPrice1 : oddData?.LayPrice1,
                        ),
                      )
                    ? getFancyOddVolume()
                    : ""
                : isNumber(Number(odd?.price)) && odd?.price === 0
                  ? "-"
                  : isNumber(Number(odd?.price))
                    ? getOddVolume()
                    : ""}
            </span>
          </span>
          {isChanged && (
            <span className="absolute top-0 left-0 w-full h-full highLightChange"></span>
          )}
        </div>
      </span>
    </>
  );
});

export default OddButton;
